import { Loader2, OctagonAlert, TriangleAlert } from 'lucide-react';

export type BannerStatusType = 'info' | 'warn' | 'failed';

export interface BannerStatus {
  type: BannerStatusType;
  message: string;
}

interface ConversationCountBannerProps {
  loading?: boolean;
  status?: BannerStatus | null;
}

const STATUS_STYLES: Record<BannerStatusType, string> = {
  info: 'border-border bg-muted text-stone-500',
  warn: 'border-amber-400 bg-amber-50 text-stone-500',
  failed: 'border-red-400 bg-red-50 text-stone-500',
};

const STATUS_ICONS: Record<BannerStatusType, React.ReactNode> = {
  info: null,
  warn: <TriangleAlert className="h-3.5 w-3.5 text-amber-500" />,
  failed: <OctagonAlert className="h-3.5 w-3.5 text-red-500" />,
};

export function ConversationCountBanner({ loading, status }: ConversationCountBannerProps) {
  if (loading) {
    return (
      <div className="flex items-center gap-2 rounded-md border border-border bg-transparent px-3 py-2 text-stone-500 text-xs">
        <Loader2 className="h-3.5 w-3.5 animate-spin" />
        <span>Loading conversations count…</span>
      </div>
    );
  }
  if (!status) return null;
  return (
    <div
      className={[
        'flex items-center gap-2 rounded-md border px-3 py-2 text-xs',
        STATUS_STYLES[status.type],
      ].join(' ')}
    >
      {STATUS_ICONS[status.type]}
      <span>{status.message}</span>
    </div>
  );
}
